import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import zoomSdk from "@zoom/appssdk";
import InMeeting from "./features/inMeeting/InMeeting";
import Login from "./features/login/Login";
import SummaryDetail from "./features/legacy/inMeeting/summary/SummaryDetails";
import SummaryDetailInClient from "./features/mainClient/summaryTab/SummaryDetailInClient";
import MainClientHome from "./features/mainClient/MainClientHome";
import LogManager from "./utils/logManager";
import { useFeatureFlags } from "./context/FeatureFlagsContext";
import Loading from "./components/Loading";
import { ZOOM_RUNNING_CONTEXT } from "./constants";

// Routing shell. Waits for feature flags (<Loading/> while null) before the in-meeting route, and
// owns the client-route visibility bounce back into the meeting.
const AppRoutes = () => {
  const featureFlags = useFeatureFlags();
  const [lastKnownContext, setLastKnownContext] = useState(null);

  useEffect(() => {
    const handleVisibilityChange = async () => {
      if (window.location.pathname.startsWith("/client") && document.visibilityState === 'visible' && lastKnownContext === ZOOM_RUNNING_CONTEXT.IN_MAIN_CLIENT) {
        LogManager.info('App became visible on client route, checking context...');
        try {
          const newContext = await zoomSdk.getRunningContext();
          LogManager.info(`Current SDK context: ${newContext.context}, Last known context: ${lastKnownContext}`);

          if (newContext.context !== lastKnownContext) {
            LogManager.info(`Context changed from ${lastKnownContext} to ${newContext.context}`);
            if (newContext.context === ZOOM_RUNNING_CONTEXT.IN_MEETING) {
              window.location.href = `${window.location.origin}/`;
            }
          }
          setLastKnownContext(newContext.context);
        } catch (error) {
          LogManager.error('Error checking context:', error);
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [lastKnownContext]);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/meeting/summary/:id" element={<SummaryDetail />} />
      <Route path="/client" element={<MainClientHome featureFlags={featureFlags} />} />
      <Route path="/client/summary/:id" element={<SummaryDetailInClient />} />
      <Route path="*" element={featureFlags === null ? <Loading /> : <InMeeting setLastKnownContext={setLastKnownContext} />} />
    </Routes>
  );
};

export default AppRoutes;
